<template>
	<figure class="swiper-container big_banner_wrap" v-if="swiperImgArray.length >= 1">
		<div class="swiper-wrapper">
			<div v-for="(item, index) in swiperImgArray" :key="index" class="swiper-slide"><img :src="item" alt="" width="750" height="464" /></div>
		</div>
		<div class="swiper-pagination paging"></div>
	</figure>
</template>

<script>
// import '../../../static/swiper.css';
// import { swiper, swiperSlide } from 'vue-awesome-swiper';

import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
	name: 'ScopeAdvertSwiper',
	props: {
		swiperImgArray: {
			type: Array
			// required: true
		},
		autoPlay: {
			type: Boolean
		},
		swiperWrapClass: {
			type: String
		}
	},
	data() {
		return {
			swiperHeader: null
		};
	},
	mounted() {
		this.initSwiper();
	},
	methods: {
		initSwiper() {
			let that = this;
			if (this.swiperImgArray.length > 1) {
				this.$nextTick(function() {
					// console.log('autoPlay=>', that.autoPlay);
					if (that.autoPlay) {
						that.swiperHeader = new Swiper('.big_banner_wrap', {
							loop: true,
							autoplay: {
								delay: 3000,
								disableOnInteraction: false
							},
							pagination: {
								el: '.swiper-pagination',
								clickable: true
							}
						});
					} else {
						that.swiperHeader = new Swiper('.big_banner_wrap', {
							loop: true,
							pagination: {
								el: '.swiper-pagination',
								clickable: true
							}
						});
					}
					// console.log('swiperHeader->', that.swiperImgArray);
				});
			}
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/child-components/ScopeAdvertSwiper.vue